import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useLocation } from 'react-router-dom';
import OpenAppDialog from '../../components/OpenAppDialog';
import { AppPenetrationAction } from '../../models';
import { getMobileOS } from '../../utils/mobileOS';
import { SellingAreaStatus } from './state';

const mobileOS = getMobileOS();

/**
 * Every other selling-area dialog is driven by the URL. Keep this list in sync
 * when a new one is added, or the two dialogs will stack.
 */
export function isAnotherDialogOpen(location: { pathname: string; search: string }, showPaymentModal: boolean): boolean {
	const params = new URLSearchParams(location.search);
	return showPaymentModal
		|| location.pathname.indexOf('cart') > -1 // CartDialog
		|| params.get('diet_preference') === 'show' // DialogPreference
		|| params.get('unsellable-item-info-banner') === 'open' // UnsellableItemInfoPopup
		|| params.get('banner') === 'open' // Banner detail
		|| params.has('description') // ItemDescriptionDialog
		|| params.get('leave') === 'need-confirm'; // FridgeConfirmationDialog
}

/**
 * Dialog pushing the app, configured from the admin and resolved by the locker
 * configs (time window + impulse flag). Mount it once per selling area, keyed by
 * the area id: closing hides it for this page only, the next visit shows it again.
 * It waits for any other dialog to close, so it never stacks on top of them.
 */
export default function SellingAreaOpenAppDialog({
	action,
	showPaymentModal,
}: {
	action: AppPenetrationAction;
	showPaymentModal: boolean;
}) {
	const location = useLocation();
	const status = useSelector((state: any) => state.status);
	const cart = useSelector((state: any) => state.cart);
	const [closed, setClosed] = useState(false);

	if (!mobileOS) {
		return null;
	}

	const isPreview = new URLSearchParams(location.search).get('mode') === 'preview';
	const open = !closed
		&& status === SellingAreaStatus.DATA_FETCHED
		// Same audience as the old banner: never in the way of someone already buying.
		&& (isPreview || !cart)
		&& !isAnotherDialogOpen(location, showPaymentModal);

	return (
		<OpenAppDialog
			open={open}
			action={action}
			page="SELLING_AREA"
			onClose={() => setClosed(true)}
		/>
	);
}
